/**
 * Historyview for comorbidities, infection and procedures
 * Columns and their headers are chosen based on documentType. If empty, comorbidity is used (for older entries).
 * In case of 'other diagnoses', the description is also displayed in its own column.
 */

import React from 'react';
import { path, is, sortWith, descend, compose } from 'ramda';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';

import { formatHeaderDate, dateValue } from 'lib/dateDisplay';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

export const sorter = sortWith([
  descend(compose(dateValue, path(['content', 'diagnosisDate']))),
  descend(compose(dateValue, path(['createDate']))),
]);

const msg = id => ({ id });

const historyMapper =
  (name, edit) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={formatHeaderDate(path(['content', 'diagnosisDate'], d), 'DD.MM.YYYY')} active={true}>
        {<CommonHistoryEntryControls action={() => edit(name, d.documentId, getLatestFinishedCommitData(d))} />}
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        {path(['content', 'diagnosisType'], d) === 'comorbidity' && (
          <HistoryEntryColumn header={formatMessage(msg('comorbidity.sections.comorbidity'))}>
            {is(String, path(['content', 'diagnosis'], d)) && (
              <p>{formatMessage(msg(path(['content', 'diagnosis'], d)))}</p>
            )}
          </HistoryEntryColumn>
        )}
        {path(['content', 'diagnosisType'], d) === 'infection' && (
          <HistoryEntryColumn header={formatMessage(msg('comorbidity.sections.infection'))}>
            {is(String, path(['content', 'diagnosis'], d)) && (
              <p>{formatMessage(msg(path(['content', 'diagnosis'], d)))}</p>
            )}
          </HistoryEntryColumn>
        )}
        {path(['content', 'diagnosisType'], d) === 'procedure' && (
          <HistoryEntryColumn header={formatMessage(msg('comorbidity.sections.procedure'))}>
            {is(String, path(['content', 'diagnosis'], d)) && (
              <p>{formatMessage(msg(path(['content', 'diagnosis'], d)))}</p>
            )}
          </HistoryEntryColumn>
        )}
        {!path(['content', 'diagnosisType'], d) && (
          <HistoryEntryColumn header={formatMessage(msg('comorbidity.sections.empty'))}>
            {is(String, path(['content', 'diagnosis'], d)) && (
              <p>{formatMessage(msg(path(['content', 'diagnosis'], d)))}</p>
            )}
          </HistoryEntryColumn>
        )}
        {path(['content', 'diagnosis'], d) === 'comorbidity.diagnosis.other' && (
          <HistoryEntryColumn header={formatMessage(msg('comorbidity.labels.other'))}>
            {is(String, path(['content', 'otherDetail'], d)) && (
              <p style={{ maxWidth: '40rem', overflowWrap: 'break-word' }}>{path(['content', 'otherDetail'], d)}</p>
            )}
          </HistoryEntryColumn>
        )}
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
